/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import ImageAPI from 'material/embeds/imageapi/imageapi_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/imageselector/imageselector_styles';



/* ========== ~~~~~~~~~~ EMBED IMAGE SELECTOR ~~~~~~~~~~ ========== */
class ImageSelector extends Component {
	constructor(props) {
		super(props);
		this.state = { phase: 'loading' };
	}
	componentDidMount() {
        setTimeout(() => {
            this.setState({
                phase: 'loaded'
            });
        }, 100);
    }
    isActive = () => this.props.currentStepPage === 'customize';
    activeImageSelect = () => this.props.activeSelection !== 'none';
    showPlacement = () => this.props.location === 'in-content' ? 'incontent' : 'rail';
	render() {
	    return(
	        <div className={`imageselector ${this.props.classes.imageselector} ${this.state.phase} isActive-${this.isActive()} activeImageSelect-${this.activeImageSelect()} ${this.showPlacement()}`}>
	            <ImageAPI />
	        </div>
	    );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageSelector);
